import type { ReduxError } from '@universal/errors';
import { produce } from 'immer';
import { Action, createAsyncAction, createReducer } from 'typesafe-actions';
import { NafEvents } from '../../../../types/nafEvents';

export enum Actions {
  GET_NAF_EVENTS = 'naf/centers/GET_NAF_EVENTS',
  GET_NAF_EVENTS_SUCCESS = 'naf/centers/GET_NAF_EVENTS_SUCCESS',
  GET_NAF_EVENTS_FAIL = 'naf/centers/GET_NAF_EVENTS_FAIL',
  GET_NAF_EVENTS_CANCEL = 'naf/centers/GET_NAF_EVENTS_CANCEL',
}

type FetchState = 'initial' | 'isUpdating' | 'success' | 'error' | 'cancelled';

export interface State {
  monthlyEvents: NafEvents[];
  fetchState: FetchState;
  errorState?: ReduxError;
  validation?: Validation;
  total?: number;
}

export type Validation = {
  reason: string;
  message: string;
};

export const initialState: State = {
  monthlyEvents: [],
  fetchState: 'initial',
};

export const actions = {
  getNafEvents: createAsyncAction(
    Actions.GET_NAF_EVENTS, // request payload creator
    Actions.GET_NAF_EVENTS_SUCCESS, // success payload creator
    Actions.GET_NAF_EVENTS_FAIL, // failure payload creator
    Actions.GET_NAF_EVENTS_CANCEL, // optional cancel payload creator
  )<
    { organizer?: string; take: number; postalNumber?: string },
    { items: NafEvents[]; total: number; validation?: Validation },
    ReduxError,
    undefined
  >(),
};

export const reducers = createReducer<State, Action>(initialState, {})
  .handleAction(actions.getNafEvents.request, (state = initialState) =>
    produce(state, (draftState) => {
      draftState.fetchState = 'isUpdating';
    }),
  )
  .handleAction(actions.getNafEvents.success, (state = initialState, action) =>
    produce(state, (draftState) => {
      draftState.fetchState = 'success';
      draftState.monthlyEvents = action.payload.items;
      draftState.total = action.payload.total;
      draftState.errorState = undefined;
      draftState.validation = undefined;
    }),
  )
  .handleAction(actions.getNafEvents.failure, (state = initialState, action) =>
    produce(state, (draftState) => {
      draftState.fetchState = 'error';
      draftState.errorState = action.payload;
      if ((action.payload as any).message) {
        draftState.validation = action.payload as unknown as Validation;
      }
    }),
  )
  .handleAction(actions.getNafEvents.cancel, (state = initialState) =>
    produce(state, (draftState) => {
      draftState.fetchState = 'cancelled';
    }),
  );
